import { render, staticRenderFns } from "./GlobalSummary.vue?vue&type=template&id=56c7ae02&"
import script from "./GlobalSummary.vue?vue&type=script&lang=js&"
export * from "./GlobalSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c7ae02')) {
      api.createRecord('56c7ae02', component.options)
    } else {
      api.reload('56c7ae02', component.options)
    }
    module.hot.accept("./GlobalSummary.vue?vue&type=template&id=56c7ae02&", function () {
      api.rerender('56c7ae02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/GlobalSummary.vue"
export default component.exports